import {
  TOTAL_USER_COUNT,
  TOTAL_WEEKLY_USER_COUNT,
  TOTAL_PREVIOUS_WEEKLY_USER_COUNT,
  ADMIN_USER_DETAILS_LOADING,
  RESET_ADMIN_USER_DETAILS_LOADING,
  CHANGE_STREAM_TOTAL_USER_COUNT,
} from '../actions/types';

const initialState = {
  loading: false,
  totalUserCount: 0,
  weeklyCount: 0,
  previousWeekCount: 0,
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case CHANGE_STREAM_TOTAL_USER_COUNT:
      return {
        ...state,
        totalUserCount: action.payload,
      };
    case TOTAL_USER_COUNT:
      return {
        ...state,
        totalUserCount: action.payload,
      };
    case TOTAL_WEEKLY_USER_COUNT:
      return {
        ...state,
        weeklyCount: action.payload,
      };
    case TOTAL_PREVIOUS_WEEKLY_USER_COUNT:
      return {
        ...state,
        previousWeekCount: action.payload,
      };
    case ADMIN_USER_DETAILS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESET_ADMIN_USER_DETAILS_LOADING:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}

export default reducer;
